import React from 'react';

const ProfileIconSmall = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.222 9.22223C10.3968 9.22223 9.60551 8.89445 9.02206 8.311C8.43862 7.72756 8.11084 6.93623 8.11084 6.11111C8.11084 5.286 8.43862 4.49467 9.02206 3.91122C9.60551 3.32778 10.3968 3 11.222 3C12.0471 3 12.8384 3.32778 13.4218 3.91122C14.0053 4.49467 14.3331 5.286 14.3331 6.11111C14.3331 6.93623 14.0053 7.72756 13.4218 8.311C12.8384 8.89445 12.0471 9.22223 11.222 9.22223Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M5 18.5553V17.7775C5 16.5398 5.49167 15.3528 6.36684 14.4777C7.24201 13.6025 8.42899 13.1108 9.66667 13.1108H12.7778C14.0155 13.1108 15.2025 13.6025 16.0776 14.4777C16.9528 15.3528 17.4445 16.5398 17.4445 17.7775V18.5553"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export default ProfileIconSmall;
